import { Icon, Text, Tooltip } from '@ksyos/design-system';
import classnames from 'classnames';

export interface IFormLabelProps {
    children?: React.ReactNode;
    clarification?: string;
    className?: string;
    isRequired?: boolean;
    stacked?: boolean;
    tooltipText?: React.ReactNode;
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function FormLabel(props: IFormLabelProps) {
    return (
        <label
            className={classnames(
                props.stacked ? 'formlabel-stacked' : 'col-form-label col-md-6',
                props.className || ''
            )}
            data-dd-privacy="allow"
        >
            {props.children}
            {props.isRequired && (
                <Text
                    as="span"
                    color="secondary"
                    fontWeight="bold"
                    ml={0.5}
                    size="sm"
                >
                    *
                </Text>
            )}
            {props.tooltipText && (
                <Tooltip content={props.tooltipText}>
                    <Icon
                        color="primary"
                        icon="information"
                        sx={{ ml: 2 }}
                    />
                </Tooltip>
            )}
            {props.clarification && <span className="clarification">{props.clarification}</span>}
        </label>
    );
}
